import { useMemo, useState } from "react";

export default function useCopilotConversation() {
  const [conversation, setConversation] = useState(null);

  const messages = useMemo(() => {
    return Array.isArray(conversation?.messages)
      ? conversation.messages
      : [];
  }, [conversation]);

  const appendOptimisticMessage = (message) => {
    setConversation((current) => ({
      ...(current || {
        id: null,
        title: message.content,
        messages: []
      }),
      messages: [...(current?.messages || []), message]
    }));
  };

  return {
    conversation,
    setConversation,
    messages,
    appendOptimisticMessage
  };
}